<template>
  <div class="obrigado">

    <div class="left">

      <div class="content">
        <img src="../assets/logo-bigger.png" alt="">

        <div class="title-primary">
          Em breve entraremos em contato sobre seu orçamento.
        </div>
        <!-- /.text-primary -->
        <br><br>
        <p>Enquanto isso visite nosso site e conheça nossos produtos!</p>

        <a href="https://www.pharmapele.com.br/" class="btn btn-success">IR PARA O SITE</a>
        <!-- /.btn btn-sucess -->
      </div>
      <!-- /.content -->

    </div>
    <!-- /.left -->

    <img class="woman" src="../assets/woman.png" alt="">



  </div>
</template>

<script>
export default {
  name: 'Obrigado',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.obrigado{
  background: #E5F9FF;
  min-height: 100vh;
  position: relative;

  &:before{
    content: " ";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 50%;
    background-image: url("../assets/bg-thanks.jpg");
    background-size: cover;
  }

  .left{
    width: 50%;
    padding: 25px;
    text-align: center;

    .content{
      display: inline-block;
      text-align: left;
      width: 380px;
      max-width: 100%;
      padding-top: 100px;
    }
  }

  .title-primary{
    color: #2680EB;
    font-family: Montserrat, Helvetica, Arial, sans-serif;
    font-weight: 900;
    font-size: 26px;
    margin-top: 50px;
  }

  p{
    font-family: Montserrat, Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: 700;
  }

  .woman{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;

  }
  
  @media all and (max-width: 768px) {

    .woman{
      display: none;
    }

  }

}
</style>
